// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { useCallback, useMemo, useState } from 'react'

const useTableSort = initialTableSort => {
  const [tableSort, setTableSort] = useState(initialTableSort)

  const assignSort = useCallback(columnToSort => (
    setTableSort(({ asc, col }) => ({
      col: columnToSort,
      asc: columnToSort !== col || !asc,
    }))
  ), [])

  return useMemo(() => ({
    assignSort,
    tableSort,
  }), [tableSort])
}

export default useTableSort
